import { type LLMActionConfig } from '@lighthouse/shared'
import React from 'react'

import { otherPlatformColorMap, otherPlatformIconMap } from '@/containers/OtherPlatforms/constant'
import { useGetAiModelList } from '@/shared/reusable'

import * as CM from '../styles'
import * as SC from './styles'

type LLMCardProps = {
    config: LLMActionConfig
}
const LLMCard: React.FC<LLMCardProps> = ({ config }) => {
    const { data } = useGetAiModelList()

    const aiModal = data?.find(item => item.modules.some(module => module.value === config.model))

    if (!aiModal) {
        return null
    }

    return (
        <CM.CardItemContainer>
            <CM.FieldList>
                <CM.FieldItem>
                    <SC.Icon type={otherPlatformIconMap[aiModal.type]} color={otherPlatformColorMap[aiModal.type]} size={16} />
                    <CM.FieldItemTitle>{config.model}</CM.FieldItemTitle>
                </CM.FieldItem>
            </CM.FieldList>
        </CM.CardItemContainer>
    )
}

export default LLMCard
